/**
 * Inline SVG feedback icon (ADR-0074 §3.1).
 *
 * Speech-bubble-with-exclamation glyph. Sized + styled to match IconBell
 * and the help-widget icon (24-viewBox, currentColor stroke,
 * stroke-width 2, round caps + joins, fill="none").
 */
export function IconFeedback({ size = 18 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      <line x1="12" y1="7" x2="12" y2="12" />
      <line x1="12" y1="15" x2="12" y2="15.01" />
    </svg>
  );
}
